//
//
//
//
//
//
//
//
//
//

export default {
  name: 'RadioPicker',
  props: {
    options: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      newValue: null,
    }
  },
  watch: {
    value(newValue) {
      this.newValue = newValue
    },
  },
  created() {
    this.newValue = this.value
  },
  methods: {
    input() {
      this.$emit('input', this.newValue)
    },
  },
}
